import { NewDynamicTab } from "../../../components/Page";
import { TabSwitcher } from "../Gridco_Das";
import { GridcoTitle } from "../components";
import DownloadData from "./DownloadData";

const DownloadDataWrapper = () => {
  return (
    <NewDynamicTab
      showDates={false}
      headerPrefixComponent={<TabSwitcher />}
      middleComponent={<GridcoTitle />}
      tabs={{ "Download Data": <DownloadData /> }}
      showTabs={false}
      header="Download Data "
    />
  );
};

export default DownloadDataWrapper;
